import Vue from 'vue'
import ElementUI from 'element-ui'
import './element-variables.scss'
import './assets/iconfont/iconfont.css'
import App from './App.vue'
import router from './router'
import GlobalMessageClose from './plugins/globalMessageClose'
import imagePreview from './directives/imagePreview'
import aiSelectable from './directives/aiSelectable'

Vue.directive('image-preview', imagePreview)
Vue.directive('ai-selectable', aiSelectable)

import Tabs from "@/views/components/tabs.vue";
import SelectTime from "@/views/components/selectTime.vue";
Vue.component('m-tabs', Tabs);
Vue.component('m-select-time', SelectTime);

import { formatTimeByRule } from "@/utils/index";
Vue.prototype.formatTimeByRule = formatTimeByRule;

Vue.use(ElementUI)
Vue.use(GlobalMessageClose)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
